import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export const ParallaxImage = ({ src, alt = "", className = "", children, speed = 12, eager = false }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [`-${speed}%`, `${speed}%`]);

  return (
    <div ref={ref} className={`relative overflow-hidden ${className}`}>
      <motion.div style={{ y }} className="absolute -inset-y-[15%] inset-x-0">
        <img src={src} alt={alt} className="w-full h-full object-cover" loading={eager ? "eager" : "lazy"} />
      </motion.div>
      {children}
    </div>
  );
};

export default ParallaxImage;
